import { useState, useEffect, useRef } from 'react'

import { isAuctionOver } from '../util/dateString'
import { CATEGORY_FILTER_OPTIONS, hasNoBids, isAvailableBuyItNowItem } from './categoryFilterOptions'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/auctions.module.scss'

export default function CategoryFilter({categoryFilter, setCategoryFilter, auction}) {

  const [categories, setCategories] = useState([])
  const [showCategories, setShowCategories] = useState(false)
  const categoryFilterRef = useRef(null)

  useEffect(() => {
    const auctionItems = auction?.Items || []
    const fixedItems = auction?.FixedItems || []
    const newCategories = [CATEGORY_FILTER_OPTIONS.ALL]
    
    const itemCategories = auction?.ItemCategories || []

    const usedCategories = new Set()

    auctionItems.forEach(item => {
      if (item.Category != null) usedCategories.add(item.Category)
    })

    fixedItems.forEach(item => {
      if (item.Category != null) usedCategories.add(item.Category)
    })

    newCategories.push(...itemCategories.filter(ele => usedCategories.has(ele)))

    if (auctionItems.some(hasNoBids)) newCategories.push(CATEGORY_FILTER_OPTIONS.NO_BIDS)
    if (fixedItems.length > 0) newCategories.push(CATEGORY_FILTER_OPTIONS.ALL_BUY_IT_NOW)
    if (fixedItems.some(isAvailableBuyItNowItem)) newCategories.push(CATEGORY_FILTER_OPTIONS.AVAILABLE_BUY_IT_NOW)
    
    setCategories(newCategories)
    if (categoryFilter === '') setCategoryFilter(CATEGORY_FILTER_OPTIONS.ALL)

  }, [auction])

  useEffect(() => {
    if (!showCategories) return undefined

    const handleClickOutside = (event) => {
      if (!categoryFilterRef.current?.contains(event.target)) {
        setShowCategories(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchstart', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [showCategories])

  const handleCategoryClick = (category) => {
    setCategoryFilter(category)
    setShowCategories(false)
  }
  const toggleCategoryDropdown = () => setShowCategories(!showCategories)

  //if the auction is over, don't show the category filter
  if (isAuctionOver(auction)) return <></>
  
  return (
    <div className={css['category-filter-shell']} ref={categoryFilterRef}>
      <div className={`${themeCss['box-left-yellow-accent-content']} ${css['category-filter-container']}`}>
        <button
          type='button'
          className={css['category-filter-header']}
          onClick={() => toggleCategoryDropdown()}
          aria-expanded={showCategories}
          aria-label='Toggle category filters'
        >
          <span></span>
          <span className={css['category-filter-title']}>Filter Items</span>
          <span className={css['category-filter-arrow']}>{showCategories ? '▲' : '▼'}</span>
        </button>

        {showCategories && (
          <div className={`${themeCss['box-left-yellow-accent-content']} ${css['category-filter-dropdown']}`}>
            {categories.map((category, index) => (
              <div key={index} onClick={() => handleCategoryClick(category)}>
                <p className={categoryFilter === category ? css['category-filter-selected'] : css['category-filter-option']}>
                  {category}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
